import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewGenericContentSchema() {
  const { t } = useTranslation('settings')

  return z.object({
    tagContent: z.string().min(1, {
      message: t(
        'generic_content.drawer_new_generic_content.schema.tag_content.required',
      ),
    }),
    contentType: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
          __isNew__: z.boolean().optional(),
        }),
      )
      .nonempty({
        message: t(
          'generic_content.drawer_new_generic_content.schema.content_type.required',
        ),
      }),
    relativeKeys: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
          __isNew__: z.boolean().optional(),
        }),
      )
      .optional()
      .default([]),
    searchTags: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
          __isNew__: z.boolean().optional(),
        }),
      )
      .optional()
      .default([]),
    fieldKey: z.string().min(1, {
      message: t(
        'generic_content.drawer_new_generic_content.schema.field_key.required',
      ),
    }),
    fieldValue: z.string().min(1, {
      message: t(
        'generic_content.drawer_new_generic_content.schema.field_value.required',
      ),
    }),
    infoMessage: z.string().optional().default(''),
  })
}

export type NewGenericContentForm = z.infer<
  ReturnType<typeof NewGenericContentSchema>
>
